<template>
  <div class="filters__group" :class="{
    'filters__group--visible':status,
    'filters__group--hidden':!status
  }">
    <div class="filters__group__heading">
      <div class="filters__group__title">{{ filter.filter.label }}</div>
      <div class="filters__group__clear" @click="clear()" v-if="showClear">Wyczyść</div>
      <div class="filters__group__arrow" @click="toggle()"></div>
    </div>
    <template v-if="status">
      <slot></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: "wrapper",
  components: {},
  props: {
    filter: Object,
    showClear: Boolean
  },
  data() {
    return {
      storageKey: null,
      status: true,
    };
  },
  mounted() {
    this.storageKey = 'filter_visibility_status_' + this.filter.filter.slug;
    let val = localStorage.getItem(this.storageKey);
    this.status = val === null ? this.status : JSON.parse(val);
  },
  computed: {},
  emits: ['clear'],
  watch: {
    status() {
      localStorage.setItem(this.storageKey, this.status);
    }
  },
  methods: {
    toggle() {
      this.status = !this.status;
    },
    clear() {
      this.$emit('clear');
    },
    hide() {
      this.status = false;
    },
    show() {
      this.status = true;
    }
  }
};
</script>
